import { getSelectedCookie } from "../../../state/selectors";
import React from "react";
import { connect } from "react-redux";
import Button from "../../shared/button/Button";
import Icon from "../../shared/icon/Icon";
import Link from "../../shared/link/Link";
import { cmsLink } from "../../../utils/link.utils";
import { ReactComponent as OptionFull } from "../../../assets/img/icons/option_full.svg";
import { ReactComponent as OptionMiddle } from "../../../assets/img/icons/option_middle.svg";
import { ReactComponent as OptionMin } from "../../../assets/img/icons/option_min.svg";
import { ReactComponent as Check } from "../../../assets/img/icons/check.svg";
import { ReactComponent as Close } from "../../../assets/img/icons/close.svg";
import {
  COOKIE_HIGHLY_RESTRICTED,
  COOKIE_RESTRICTED,
  COOKIE_STANDARD,
  options,
} from "../../../utils/cookieMessage.utils";
import * as cookieMessageActions from "../../../state/actions/cookieMessage.actions";

class Settings extends React.Component<any> {
  availableIcons: {} = {
    option_full: OptionFull,
    option_middle: OptionMiddle,
    option_min: OptionMin,
    check: Check,
    close: Close,
  };
  trackingValues = [
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.1",
      }),
      trackedOn: [COOKIE_HIGHLY_RESTRICTED, COOKIE_RESTRICTED, COOKIE_STANDARD],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.2",
      }),
      trackedOn: [COOKIE_HIGHLY_RESTRICTED, COOKIE_RESTRICTED, COOKIE_STANDARD],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.3",
      }),
      trackedOn: [COOKIE_STANDARD, COOKIE_RESTRICTED],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.4",
      }),
      trackedOn: [COOKIE_STANDARD, COOKIE_RESTRICTED],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.5",
      }),
      trackedOn: [COOKIE_STANDARD, COOKIE_RESTRICTED],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.6",
      }),
      trackedOn: [COOKIE_STANDARD],
    },
    {
      value: this.props.intl.formatMessage({
        id: "CookieMessage.settings.option.7",
      }),
      trackedOn: [],
    },
  ];

  handleOptionChange = (selected) => {
    this.props.setSelected(selected);
  };

  handleClick = () => {
    const cookieValue = options.filter(
      (option) => option.key === this.props.selected.key
    )[0].key;
    this.props.closePopupAndSave(cookieValue);
  };

  render() {
    const { selected, deviceType, intl } = this.props;
    const cookieUrl = cmsLink(intl.formatMessage({ id: "CookiePage.url" }));

    return (
      <>
        <p>{intl.formatMessage({ id: "CookieMessage.settings.body" })}</p>

        <div className="cookie-message__settings">
          <div className="cookie-message__options">
            {options.map((option) => (
              <label className="cookie-message__option" key={option.key}>
                <div className="cookie-message__option--selector">
                  <input
                    type="radio"
                    data-test-id="cookieMessageSettingsOption"
                    value={option.key}
                    checked={!!selected && selected.key === option.key}
                    onChange={() => this.handleOptionChange(option)}
                  />
                  <Icon
                    name={option.icon}
                    size="xlarge"
                    iconComponent={this.availableIcons[option.icon]}
                  />
                </div>
                <div className="cookie-message__option--value">
                  <strong>
                    {intl.formatMessage({ id: `${option.translation}.title` })}
                  </strong>
                  <p>
                    {intl.formatMessage({ id: `${option.translation}.body` })}
                  </p>
                </div>
              </label>
            ))}
          </div>

          {deviceType.isSmall && (
            <div className="cookie-message__footer cookie-message__footer--no-border cookie-message__footer--row">
              <a
                className="button button--link"
                data-test-id="cookieMessageSettingsBackButton"
              >
                {intl.formatMessage({ id: "CookieMessage.return" })}
              </a>
              <Button
                appearance="primary"
                disabled={!selected || !selected.key}
                onClick={this.handleClick}
                text={intl.formatMessage({ id: "CookieMessage.link" })}
                data-test-id="cookieMessageSettingsAcceptButton"
              />
            </div>
          )}

          {selected && (
            <div className="cookie-message__results">
              <p>
                {intl.formatMessage({
                  id: "CookieMessage.settings.options.title",
                })}
              </p>

              <ul className="cookie-message__row cookie-message__result--list">
                {this.trackingValues.map((tracking, i) => {
                  const isAllowed =
                    tracking.trackedOn.indexOf(selected.key) !== -1;

                  return (
                    <li
                      className="cookie-message__column cookie-message__result"
                      key={i}
                    >
                      <Icon
                        name={isAllowed ? "check" : "close"}
                        iconComponent={
                          this.availableIcons[isAllowed ? "check" : "close"]
                        }
                        className={`result-icon cookie-message__result--${
                          isAllowed ? "allowed" : "forbidden"
                        }`}
                      />

                      <span className="cookie-message__result--text">
                        {tracking.value}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        <div className="cookie-message__footer">
          <Link href={cookieUrl} className="cookie-message__more-info">
            {intl.formatMessage({ id: "CookieMessage.more_information" })}
          </Link>

          {deviceType.isMediumUp && (
            <div>
              <a
                className="button button--link"
                data-test-id="cookieMessageSettingsBackButton"
              >
                {intl.formatMessage({ id: "CookieMessage.return" })}
              </a>

              <Button
                appearance="primary"
                disabled={!selected || !selected.key}
                onClick={this.handleClick}
                text={intl.formatMessage({ id: "CookieMessage.link" })}
                data-test-id="cookieMessageSettingsAcceptButton"
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selected: getSelectedCookie(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSelected: (selected) =>
    dispatch(cookieMessageActions.setSelected(selected)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);
